import { formatMandateToView } from '../../helpers/FormatPaymentHelper';

export const showCancelMandateModal = (state) => state.cancelPayment.showCancelModal;

export const getCancelApiError = (state) => state.cancelPayment.cancelApiError;

export const isCancelApiInProgress = (state) => state.cancelPayment.isCancelApiInProgress;

export const getMandateToCancel = (state) => formatMandateToView(state.cancelPayment.mandateToCancel);

export const getCancelModalName = (state) => state.cancelPayment.cancelModalName;
